import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { sharepointService } from '../services/sharepointService';
import toast from 'react-hot-toast';

export function SharePointOAuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution in React StrictMode
    if (hasProcessed.current) return;

    const processCallback = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');
      const error = searchParams.get('error');
      const errorDescription = searchParams.get('error_description');

      console.log('🔍 SharePoint OAuth Callback Debug:', {
        hasCode: !!code,
        hasState: !!state,
        hasError: !!error,
        url: window.location.href,
      });

      // Handle OAuth errors
      if (error) {
        console.error('❌ SharePoint OAuth error:', error, errorDescription);
        toast.error(`SharePoint connection failed: ${errorDescription || error}`);
        navigate('/settings/connections');
        return;
      }

      // Validate required parameters
      if (!code || !state) {
        console.error('❌ Missing OAuth parameters');
        toast.error('Invalid OAuth response. Please try again.');
        navigate('/settings/connections');
        return;
      }

      // Mark as processed
      hasProcessed.current = true;

      console.log('✅ Starting token exchange...');
      const toastId = toast.loading('Connecting to SharePoint...');

      try {
        // Exchange authorization code for tokens
        await sharepointService.completeOAuthFlow(code, state);

        console.log('✅ SharePoint connected successfully!');
        toast.success('SharePoint connected! Now configure your site.', { id: toastId });

        // Redirect to connections page
        navigate('/settings/connections');
      } catch (error) {
        console.error('❌ SharePoint OAuth completion failed:', error);
        toast.error(
          error instanceof Error ? error.message : 'Failed to connect to SharePoint',
          { id: toastId }
        );
        navigate('/settings/connections');
      }
    };

    processCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Connecting to SharePoint...
        </h2>
        <p className="text-gray-600">
          Please wait while we complete the connection.
        </p>
      </div>
    </div>
  );
}

